"use client";

import React from "react";
import { createPortal } from "react-dom";
import { NotificationProps } from "../app/utilities/interfaces";

const Notification: React.FC<NotificationProps> = ({ message, isVisible, isError }) => {
  if (!isVisible || !message) return null;

  return createPortal(
    <div
      className={`fixed top-4 right-4 px-6 py-3 rounded shadow-lg z-[9999] ${
        isError ? "bg-red-500 text-white" : "bg-automotive-red text-white"
      }`}
    >
      {message}
    </div>,
    document.body
  );
};

export default Notification;
